import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { client } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast, Toaster } from "sonner";

const ROLE_HOME = {
  technician: "/tech",
  service_coordinator: "/dispatch",
  manager: "/dispatch",
};

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await client.post("/auth/session", { session_id: sid });
        setUser(r.data);
        const home = ROLE_HOME[r.data.role] || "/dispatch";
        window.history.replaceState(null, "", home);
        navigate(home, { replace: true, state: { user: r.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign-in failed";
        console.error("Auth exchange failed", msg);
        navigate("/", { replace: true, state: { error: msg } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#F7F8FA" }}>
      <Toaster richColors position="top-right" />
      <div className="mono text-[12px]" style={{ color: "#5F6B7A" }} data-testid="auth-callback">
        Signing you in…
      </div>
    </div>
  );
}
